// PaymentsListMobile.tsx
import { IonList, IonItem, IonLabel, IonNote } from "@ionic/react";
import { FormattedMessage } from "react-intl";
import classNames from "classnames";
import { usePaymentsStore } from "../../../store/payments";
import { Settings, Payment } from "../../../interfaces";

interface Props {
  settings: Settings;
  handleClick: (payment: Payment) => void;
}

const PaymentsListMobile: React.FC<Props> = ({ settings, handleClick }) => {
  const payments = usePaymentsStore((state) => state.payments);
  if (!payments.length) {
    return (
      <IonList lines="none">
        <IonItem>
          <IonLabel className="ion-text-center w-100">
            <FormattedMessage id="common.noResults" />
          </IonLabel>
        </IonItem>
      </IonList>
    );
  }

  return (
    <IonList inset={false}>
      {payments.map((p) => {
        const contact = p.contact;
        /* Badge para el estado del pago */
        const paymentBadge = (
          <div className="flex gap-1">
            <div
              className={classNames("badge ", {
                "text-bg-light": ["expired", "active"].includes(
                  p.paymentStatus
                ),
                "text-bg-success": p.paymentStatus === "paid",
              })}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div className="fw-semibold-1">
                  {
                    <FormattedMessage
                      id={`leads.payments.${p.paymentStatus}`}
                    />
                  }
                </div>
              </div>
            </div>
          </div>
        );

        /* Badge secundario para la transferencia (solo si está pagado) */
        const transferBadge =
          p.paymentStatus === "paid" ? (
            <div className="flex gap-1">
              <div
                className={classNames("badge ", {
                  "text-bg-light": p.transferStatus === "pendingTransfer",
                  "text-bg-success": p.transferStatus === "transfered",
                })}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <div className="fw-semibold-1">
                    {
                      <FormattedMessage
                        id={`leads.payments.${p.transferStatus}`}
                      />
                    }
                  </div>
                </div>
              </div>
            </div>
          ) : null;

        return (
          <IonItem key={p.id} button onClick={() => handleClick(p)}>
            <IonLabel className="ion-text-wrap">
              <h2 className="d-flex align-items-center">
                {contact.name || contact.phoneNumber}
              </h2>
              <div className="d-flex align-items-center ion-justify-content-between">
                {p.date} <strong>{p.amount}</strong>
              </div>
              {settings.companies.length > 1 && (
                <IonNote color="medium">{p.company}</IonNote>
              )}
              <div className="mt-1 d-flex align-items-center gap-2">
                {paymentBadge}
                {transferBadge}
              </div>
            </IonLabel>
          </IonItem>
        );
      })}
    </IonList>
  );
};

export default PaymentsListMobile;
